import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf } from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";

const ShortIntro = () => {
  useEffect(() => {
    AOS.init({
      offset: 0, // Offset (in px) from the original trigger point
      delay: 300, // Delay in milliseconds before animation starts.
      duration: 1000, // Animation duration in milliseconds
      easing: "ease-in-sine", // Easing animation
      once: false, // Whether animation should happen only once
      mirror: false, // Whether the AOS should mirror elements when scrolling
    });
  }, []);

  return (
    <div className="mb-5 border-bottom container">
      <div className="row align-items-center">
        {/* Image Section */}
        <div className="col-12 col-md-6 text-center mb-4 mb-md-0">
          <img
            data-aos="fade-right"
            className="img-fluid"
            style={{ maxWidth: "70%", height: "auto" }}
            src="./images/img_home_fresh.webp"
            alt="meme_home"
          />
        </div>

        {/* Text Section */}
        <div className="col-12 col-md-6 text-muted fst-italic">
          <p
            data-aos="zoom-in"
            className="text-uppercase text-success fw-bold ps-3"
          >
            Mễ Mễ Việt Nam
          </p>
          <p data-aos="fade-left">
            <span className="text-success me-1">
              <FontAwesomeIcon icon={faLeaf} />
            </span>
            Mễ Mễ là thương hiệu của Công ty Cổ phần Thương mại và Dịch vụ WMA,
            được nghiên cứu và sản xuất riêng cho thị trường Việt Nam.
          </p>
          <p data-aos="fade-left">
            <span className="text-success me-1">
              <FontAwesomeIcon icon={faLeaf} />
            </span>
            Triết lý: Mọi người mẹ và em bé đều cần được thấu hiểu, nâng niu
            bằng những sản phẩm THIẾT THỰC - LÀNH - CHẤT để “hành trình làm mẹ”
            sẽ luôn là những chặng đường hạnh phúc, bình yên.
          </p>
          <p data-aos="fade-left">
            <span className="text-success me-1">
              <FontAwesomeIcon icon={faLeaf} />
            </span>
            Sứ mệnh: Thấu hiểu cùng mẹ - Sẻ chia cùng bố - Trưởng thành cùng
            con!
          </p>
          <p data-aos="fade-up">
            <span className="text-success me-1">
              <FontAwesomeIcon icon={faLeaf} />
            </span>
            Tầm nhìn: Đưa Mễ Mễ trở thành một thương hiệu Việt luôn song hành
            cùng mẹ và bé!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShortIntro;
